import { ChangeTribeModal } from './ChangeTribeModal'

export default ChangeTribeModal;